<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  beforeCreate() {
    let skin =localStorage.getItem("sysConfig-skin") ||  window.sysConfig.skin;
    document.body.classList.add(skin);
    localStorage.setItem("sysConfig-skin", skin);
  },
  methods: {

  },
}
</script>

<style>
#app {
  width: 100%;
  height: 100%;
}
</style>
